import { NgTemplateOutlet } from '@angular/common';
import { Component } from '@angular/core';
import { EmptyContentListElement } from '../../../components/empty-content-list-element/empty-content-list-element';

@Component({
  selector: 'app-planning-list',
  imports: [NgTemplateOutlet, EmptyContentListElement],
  templateUrl: './planning-list.html',
  styleUrl: '../content-list.scss',
})
export class PlanningList {}
